/**
 * BETA — auth handlers. All endpoints return synthetic data; no real auth.
 */
import { getDemoUser } from "../data/users.js";

const TOKEN = "BETA_DEMO_TOKEN";

export function register(route) {
  route("POST", "/auth/login", (ctx) => {
    const role = ctx.store.role || "PROPRIETAIRE";
    return { access_token: TOKEN, refresh_token: TOKEN, user: getDemoUser(role) };
  });

  route("POST", "/auth/logout", () => ({ success: true }));

  route("POST", "/auth/refresh", () => ({
    data: { access_token: TOKEN, refresh_token: TOKEN },
  }));

  route("GET", "/auth/me", (ctx) => {
    const role = ctx.store.role || "PROPRIETAIRE";
    return getDemoUser(role);
  });

  route("POST", "/auth/register-fournisseur", () => ({
    success: true,
    message: "Demande enregistrée (démo)",
  }));
}
